import { __rest, __assign } from '../../../../_virtual/_tslib.js';
import React from 'react';
import { NavButton as NavButton$1, Loading, LoadingContainer, LoadingSpinner, NavButtonIcon, NavButtonChild, ButtonBadge } from './Button.styles.js';
import { theme } from '@citygross/design-tokens';

function NavButton(_a) {
  var _b = _a.color,
      color = _b === void 0 ? 'darkest' : _b,
      height = _a.height,
      icon = _a.icon,
      isDisabled = _a.isDisabled,
      loading = _a.loading,
      noWrap = _a.noWrap,
      _onClick = _a.onClick,
      border = _a.border,
      shadow = _a.shadow,
      width = _a.width,
      buttonBadge = _a.buttonBadge,
      badgeBackground = _a.badgeBackground,
      size = _a.size,
      flexReverse = _a.flexReverse,
      childGap = _a.childGap,
      children = _a.children,
      _c = _a.center,
      center = _c === void 0 ? true : _c,
      fullWidth = _a.fullWidth,
      xsSize = _a.xsSize,
      borderRadius = _a.borderRadius,
      hoverBackground = _a.hoverBackground,
      noShadow = _a.noShadow,
      tabIndex = _a.tabIndex,
      keepLabel = _a.keepLabel,
      minWidth = _a.minWidth,
      badgeMinWidth = _a.badgeMinWidth,
      id = _a.id,
      props = __rest(_a, ["color", "height", "icon", "isDisabled", "loading", "noWrap", "onClick", "border", "shadow", "width", "buttonBadge", "badgeBackground", "size", "flexReverse", "childGap", "children", "center", "fullWidth", "xsSize", "borderRadius", "hoverBackground", "noShadow", "tabIndex", "keepLabel", "minWidth", "badgeMinWidth", "id"]);

  return React.createElement(NavButton$1, __assign({
    tabIndex: tabIndex,
    color: theme && theme.palette ? theme === null || theme === void 0 ? void 0 : theme.palette[color] : '#333333',
    height: height,
    icon: icon,
    keepLabel: keepLabel,
    isDisabled: loading || isDisabled,
    loading: loading || null,
    noWrap: noWrap,
    onClick: function onClick(e) {
      return _onClick && _onClick(e);
    },
    width: width,
    border: border,
    shadow: shadow,
    center: center,
    fullWidth: fullWidth,
    flexReverse: flexReverse,
    size: size,
    xsSize: xsSize,
    borderRadius: borderRadius,
    childGap: childGap,
    hoverBackground: hoverBackground,
    noShadow: noShadow,
    minWidth: minWidth,
    id: id || 'nav-button'
  }, props), loading && React.createElement(Loading, null, React.createElement(LoadingContainer, null, React.createElement(LoadingSpinner, null))), !keepLabel && React.createElement(NavButtonIcon, null, icon), icon ? React.createElement(NavButtonChild, {
    size: size,
    flexReverse: flexReverse,
    noWrap: noWrap,
    keepLabel: keepLabel,
    childGap: childGap
  }, icon, children) : children, buttonBadge ? React.createElement(ButtonBadge, {
    background: badgeBackground,
    smallBadge: true,
    minWidth: badgeMinWidth
  }, buttonBadge) : null);
}

export { NavButton };